(function () {
  'use strict';
  if (window.SkiSisesAdsIntent) return;
  var names = {
    brand_follow: 'brand_follow', wishlist: 'add_to_wishlist', back_in_stock: 'back_in_stock_request',
    price_drop: 'price_drop_signup', size: 'size_alert_signup',
    size_collection: 'size_alert_signup', rental_quote: 'rental_quote_request', area_guide: 'area_guide_request',
    whatsapp: 'whatsapp_click', phone: 'phone_click'
  };
  var seen = new Set();
  // Load the documented API if the banner has not initialized it yet. No interaction is queued.
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
  function allowed() {
    try {
      var p = window.Shopify.customerPrivacy;
      return p.analyticsProcessingAllowed() && p.marketingAllowed() && p.saleOfDataAllowed();
    } catch (_) { return false; }
  }
  function track(kind, data) {
    var name = names[kind];
    if (!name || !allowed() || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    data = data || {};
    // Only catalog fields; never forward request bodies, identities, sizes, URLs, or message text.
    var params = { intent_type: kind };
    ['product_id', 'variant_id'].forEach(function (key) {
      var value = String(data[key] || '').replace(/^gid:\/\/shopify\/(Product|ProductVariant)\//, '');
      if (/^\d+$/.test(value)) params[key] = value;
    });
    ['brand', 'collection_handle', 'product_handle'].forEach(function (key) {
      var value = typeof data[key] === 'string' ? data[key].trim() : '';
      if (value && value.length <= 100 && !/[@?&#\n\r]|https?:/i.test(value)) params[key] = value;
    });
    var key = name + ':' + JSON.stringify(params);
    if (seen.has(key)) return;
    seen.add(key);
    try {
      var result = window.Shopify.analytics.publish('sks_ads_intent', { event_name: name, params: params });
      if (result && typeof result.catch === 'function') result.catch(function () { seen.delete(key); });
    } catch (_) { seen.delete(key); }
  }
  window.SkiSisesAdsIntent = { track: track };
  document.addEventListener('sks:ads-intent', function (event) {
    track(event.detail && event.detail.kind, event.detail && event.detail.data);
  });
  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    // SetuBridge's agent contact opens WhatsApp from a div rather than an anchor.
    // Opening its launcher alone is not a contact action; never read data-no.
    var agent = event.target && event.target.closest && event.target.closest('.whatsapp-chat-form .agent_data[data-no]');
    if (agent) { track('whatsapp'); return; }
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (/^tel:/i.test(href)) { track('phone'); return; }
    try {
      var url = new URL(href, location.href);
      if (url.protocol === 'whatsapp:' || (url.protocol === 'https:' && ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname))) track('whatsapp');
    } catch (_) {}
  }, true);
})();
